import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from './AppIcon';
import Button from './ui/Button';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigationItems = [
    { path: '/homepage', label: 'Home' },
    { path: '/menu', label: 'Menu' },
    { path: '/locations', label: 'Locations' },
    { path: '/about', label: 'About' },
    { path: '/ambience-gallery', label: 'Gallery' },
  ];

  const isActivePath = (path) => location?.pathname === path;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <header className="header">
        <div className="header-container">
          <div className="header-content">
            <Link to="/homepage" className="header-logo">
              <div className="header-logo-icon">
                <Icon name="Utensils" size={24} color="#FFFFFF" />
              </div>
              <span className="header-logo-text">Taco Street Digital</span>
            </Link>

            <nav className="header-nav">
              {navigationItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  className={`header-nav-link ${isActivePath(item?.path) ? 'active' : ''}`}
                >
                  {item?.label}
                </Link>
              ))}
            </nav>

            <div className="header-actions">
              <Button
                variant="default"
                size="default"
                iconName="ShoppingCart"
                iconPosition="left"
                className="hidden sm:flex"
              >
                Order Now
              </Button>
              
              <button
                onClick={toggleMobileMenu}
                className="mobile-menu-button"
                aria-label="Toggle mobile menu"
              >
                <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={24} />
              </button>
            </div>
          </div>
        </div>
      </header>
      <div
        className={`mobile-menu-overlay ${!isMobileMenuOpen ? 'hidden' : ''}`}
        onClick={closeMobileMenu}
      />
      <div className={`mobile-menu ${!isMobileMenuOpen ? 'closed' : ''}`}>
        <div className="mobile-menu-header">
          <span className="text-lg font-semibold text-foreground">Menu</span>
          <button
            onClick={closeMobileMenu}
            className="mobile-menu-close"
            aria-label="Close mobile menu"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        <nav className="mobile-menu-nav">
          {navigationItems?.map((item) => (
            <Link
              key={item?.path}
              to={item?.path}
              className={`mobile-menu-link ${isActivePath(item?.path) ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              {item?.label}
            </Link>
          ))}
          
          <Button
            variant="default"
            size="default"
            iconName="ShoppingCart"
            iconPosition="left"
            fullWidth
            className="mt-4"
          >
            Order Now
          </Button>
        </nav>
      </div>
    </>
  );
};

export default Header;